export default {
  LIST(state, data) {
    state.topics = data
  },
}
